<template>
  <div>
    <el-form ref="loginForm" :model="form" :rules="rules" label-width="120px" class="login-box">
      <h3 class="login-title">Welcome to Online Classroom</h3>
      <el-form-item label="User Name" prop="username">
        <el-input type="text" placeholder="Please Enter Your User Name." v-model="form.username" />
      </el-form-item>
      <el-form-item label="Password" prop="password">
        <el-input type="password" placeholder="Please Enter Password." v-model="form.password" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" v-on:click="onSubmit('loginForm')" class="login-button">Login</el-button>
      </el-form-item>
    </el-form>

    <el-dialog title="温馨提示" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
      <span>{{ dialogInfo }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">OK</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { tryLogin } from "@/api";
import { mapMutations } from "vuex";

export default {
  name: "Login",
  data() {
    return {
      form: {
        username: "",
        password: ""
      },

      // 表单验证，需要在 el-form-item 元素中增加 prop 属性
      rules: {
        username: [
          {
            required: true,
            message: "User Name can't be empty!",
            trigger: "blur"
          }
        ],
        password: [
          {
            required: true,
            message: "Password can't be empty!",
            trigger: "blur"
          }
        ]
      },

      dialogVisible: false,
      dialogInfo: ""
    };
  },
  methods: {
    ...mapMutations(["changeLogin"]),
    onSubmit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          tryLogin(this.form.username, this.form.password).then(res => {
            if (!res.user_id || !res.user_power) {
              this.dialogVisible = true;
              this.dialogInfo =
                "Incorrect UserName or Password. Please Check Your Input.";
            } else {
              this.changeLogin(res);
              this.$message({
                type: 'success',
                message: 'Login Success!'
              })
              this.$router.push("/classroom-list");
            }
          });
        } else {
          this.dialogVisible = true;
          this.dialogInfo = "Please Complete Your UserName or Password";
          return false;
        }
      });
    },
    handleClose() {}
  }
};
</script>

<style>
.login-box {
  border: 1px solid #dcdfe6;
  width: 390px;
  margin: 180px auto;
  padding: 35px 35px 15px 35px;
  border-radius: 5px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  box-shadow: 0 0 25px #909399;
}

.login-title {
  text-align: center;
  margin: 0 auto 40px auto;
  color: #303133;
}

.login-button {
  float: right;
}
</style>